import { Swiper, Navigation, Pagination, Thumbs, Controller } from 'swiper';
import elementExists from '../../utils/elementExists';
import eventBus from '../../core/services/event-bus';

const TestimonialSwiper = function(){
    document.querySelectorAll('.page-section-testimonials').forEach(testimonials => {
        const testimonialsBody = testimonials.querySelector('.swiper-testimonials-body');
        const testimonialsLogo = testimonials.querySelector('.swiper-testimonials-logo');
        let swiperSlides = testimonialsLogo.querySelectorAll('.swiper-slide');
        const indexVal = swiperSlides.length;

        let logoSwiper = new Swiper(testimonialsLogo, {
            loop: true,
            loopedSlides: indexVal,
            centeredSlides: true,
            slidesPerView: 'auto',
            spaceBetween: 30,
            slideToClickedSlide: true,
            // autoHeight: true,
            navigation: {
                nextEl: '.page-section-testimonials .swiper-button-next',
                prevEl: '.page-section-testimonials .swiper-button-prev',
            },
            breakpoints: {
                992: {
                    slidesPerView: 4,
                    spaceBetween: 50,
                    // autoHeight: true
                }
            }
        });

        let bodySwiper = new Swiper(testimonialsBody, {
            loop: true,
            loopedSlides: indexVal,
            spaceBetween: 0,
            autoHeight: true
        });

        bodySwiper.controller.control = logoSwiper;
        logoSwiper.controller.control = bodySwiper;   
        
    });

}

export default TestimonialSwiper